import { FiDialogsContentBase } from '../fi-dialogs/fi-dialogs-content-base';
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { IFeedbackContactSupport, IFeedbackDialogData, IFeedbackDialogResult } from './feedback';
import { BehaviorSubject } from 'rxjs';
import { FiUserDataService } from '../fi-shared-services/fi-user-data.service';
import { FiFileUpload2Service } from '../fi-insert-media/fi-file-upload2.service';
import { ContactSupportOptionType } from '@fi-shared/fi-support/fi-contact-support-dialog/fi-contact-support-dialog.component';

@Component({
    selector: 'fi-feedback-dialog',
    template: `
        <p class="hide-mobile">{{ getDescriptionTextId() | fiAppText }}</p>
        <mat-form-field class="input-group">
            <textarea
                matInput
                [placeholder]="'feedback.your_message' | fiAppText"
                [(ngModel)]="contactSupport.Description"
                matTextareaAutosize
                matAutosizeMinRows="1"
            >
            </textarea>
        </mat-form-field>

        <div class="feedback-form-wrapper">
            <div class="feedback-form-file-upload hide-mobile">
                <fi-insert-media-upload-helper #uploadHelper [multiple]="true" (onFilesSelect)="onFilesSelect($event)">
                </fi-insert-media-upload-helper>

                <div (fiDropHandler)="onFilesSelect($event)" class="file-upload-container">
                    <span>{{ 'mediaModule.drag_drop_hint_1' | fiAppText }}</span>
                    <a
                        href
                        (click)="$event.preventDefault(); uploadHelper.onBrowseDeviceInvoked()"
                        class="BrandedColor"
                        >{{ 'mediaModule.drag_drop_hint_2' | fiAppText | lowercase }}</a
                    >
                    <span>{{ 'mediaModule.drag_drop_hint_3' | fiAppText }}</span>
                </div>

                <fi-selected-files-list
                    [filesList$]="files$"
                    class="feedback-form-selected-files"
                ></fi-selected-files-list>
            </div>
            <div>
                <div class="show-mobile feedback-attach-screenshot-wrapper">
                    <ng-container *ngTemplateOutlet="feedbackAttachScreenshot"></ng-container>
                </div>

                <mat-form-field class="input-group">
                    <input
                        matInput
                        [email]="!!contactSupport.EmailAddress"
                        [placeholder]="'feedback.your_email' | fiAppText"
                        [(ngModel)]="contactSupport.EmailAddress"
                        #emailAddressModel="ngModel"
                        autocomplete="off"
                        data-lpignore="true"
                    />
                    <mat-error [fiErrorMessage]="emailAddressModel"></mat-error>
                </mat-form-field>
                <mat-form-field class="input-group">
                    <input
                        matInput
                        [placeholder]="'feedback.your_phone' | fiAppText"
                        [(ngModel)]="contactSupport.PhoneNumber"
                        #phoneNumberModel="ngModel"
                        autocomplete="off"
                        data-lpignore="true"
                    />
                    <mat-error [fiErrorMessage]="phoneNumberModel"></mat-error>
                </mat-form-field>
                <div class="hide-mobile">
                    <ng-container class="" *ngTemplateOutlet="feedbackAttachScreenshot"></ng-container>
                </div>
            </div>
        </div>

        <ng-template #feedbackAttachScreenshot>
            <mat-checkbox
                aria-label="AttachScreenshot"
                class="ScreenshotCheckbox"
                [(ngModel)]="attachScreenshot"
                aria-checked="true"
            >
                {{ 'feedback.attach_screenshot' | fiAppText }}
            </mat-checkbox>
        </ng-template>
    `,
    styleUrls: ['./feedback-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-feedback-dialog' },
    standalone: false,
})
export class FeedbackDialogComponent
    extends FiDialogsContentBase<IFeedbackDialogData, IFeedbackDialogResult>
    implements OnInit
{
    attachScreenshot = true;
    contactSupport: IFeedbackContactSupport;
    files$ = new BehaviorSubject<File[]>([]);

    private fileUpload2Service: FiFileUpload2Service;

    ngOnInit(): void {
        const userData = this.injector.get(FiUserDataService).userData;

        this.fileUpload2Service = this.injector.get(FiFileUpload2Service);

        this.contactSupport = {
            UserId: userData.UserId,
            UserName: userData.FullName,
            PhoneNumber: userData.UserPhone,
            EmailAddress: userData.UserEmail,
            IsFeedback: this.data.isFeedback,
            Description: '',
            SupportType: ContactSupportOptionType.Account,
        };
    }

    getResult() {
        return {
            attachScreenshot: this.attachScreenshot,
            files: this.files$.value,
            contactSupport: this.contactSupport,
        };
    }

    getDescriptionTextId() {
        return this.data.isFeedback ? 'feedback.description' : 'feedback.support_description';
    }

    onFilesSelect($event: ArrayLike<File>) {
        if ($event.length > 0) {
            const newFiles = this.files$.value;
            newFiles.push(...Array.from($event));
            this.files$.next(newFiles);
        }
    }
}
